import { LockedMole, Mole } from 'state/vvsgotchi/models'

const getTeamSelectUnlockAt = (lockedMoles: LockedMole[], team: Mole[]): number | undefined => {
  if (!lockedMoles || !team) return undefined

  return lockedMoles
    .filter((lm) => !team.some((m) => m.tokenId === lm.tokenId))
    .map((m) => new Date(m.unlockAt).getTime())
    .sort((a, b) => b - a)[0]
}

export default getTeamSelectUnlockAt
